import _ from "lodash"
import { HeaderBack } from '@/components/common/header';
import { LatestNewsItem, NewsItem } from '@/components/news';
import { LoadMore } from '@/components/common/loader';
import { InView } from 'react-intersection-observer';
import { EmptyData } from '@/components/common/emptyData';
import { ProfilePicture } from "../common/image";
import { Footer } from "../common/footer";
import { MyBody } from "../body/body";

export const AuthorSection = (props) =>{
    const { authorData, newsData, t, isLoadingNewsList, handleLoadMore, pageLimit, offset, totalRow, isModelTitle = undefined, loading = false } = props

    return (
        <MyBody
            t={t}
            headerComponent={
                <HeaderBack 
                    t={t}
                />
            }
        >
            <div className='authorBackground' >
                <div className='authorBackground_inner' />
            </div>
            <div className='authorContainer'>
                <div className='containerPadding'>
                    <div className='authorHeader'>
                        <div className='authorHeader_image'>
                            <ProfilePicture 
                                imagePath={!_.isEmpty(authorData?.profile_image) ? process.env.NEXT_PUBLIC_FS_URL + authorData?.profile_image : undefined}
                                size={7.8}
                            />
                        </div>
                        <div className='authorHeader_description'>
                            <div className='authorHeader_descriptionLeftBg' />
                            <div className='authorHeader_descriptionContent'>
                                <p className='fontSize_16 fontWeight_semiBold authorHeader_descriptionTitle'>
                                    {authorData?.full_name}
                                </p>
                                <p className='fontSize_12 authorHeader_descriptionText'>
                                    {authorData?.description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='authorBody containerPadding'>
                    {
                        isModelTitle ? 
                        <p className='fontSize_16 fontWeight_bold'>
                            {`${isModelTitle} ${t("review_author")}`}
                        </p>
                        :
                        <p className='fontSize_16 fontWeight_bold'>
                            {`${authorData?.full_name} ${t("feed")}`}
                        </p>
                    }
                </div>
                <LatestNewsItem data={newsData?.[0]} loading={loading} type={newsData?.[0]?.type} />
                <NewsItem data={newsData?.[1]} loading={loading} type={newsData?.[1]?.type} />
                <NewsItem data={newsData?.[2]} loading={loading} type={newsData?.[2]?.type} />
                <NewsItem data={newsData?.[3]} loading={loading} type={newsData?.[3]?.type} />
                {
                    _.reduce(newsData, (result, value, key) => {
                        key > 3 ? 
                        result.push(
                            <NewsItem key={key} data={value} type={value?.type} />
                        )
                        :
                        null
                        return result
                    },[])
                }
                {
                    _.isEmpty(newsData) &&
                    <EmptyData t={t} isLoading={isLoadingNewsList} />
                }
                {/* {
                    totalRow > (offset + pageLimit) &&
                    <InView as="div" onChange={handleLoadMore} threshold={0.2}>
                        <LoadMore t={t} />
                    </InView>
                } */}
                {
                    (totalRow > (offset + pageLimit) && isLoadingNewsList == false) &&
                    <InView as="div" onChange={handleLoadMore}>
                        {/* <LoadMore t={t} /> */}
                    </InView>
                }
                {
                    (totalRow > (offset + pageLimit) && isLoadingNewsList == true) &&
                    <LoadMore t={t} />
                }
            </div>
        </MyBody>
    )

    // return (
    //     <div className='bodyContainer'>
    //         <div className='contentContainer'>
    //             <div className='authorBackground' >
    //                 <div className='authorBackground_inner' />
    //             </div>
    //             <div className='authorContainer'>
    //                 <HeaderBack 
    //                     t={t}
    //                 />
    //                 <div className='containerPadding'>
    //                     <div className='authorHeader'>
    //                         <div className='authorHeader_image'>
    //                             <ProfilePicture 
    //                                 imagePath={!_.isEmpty(authorData?.profile_image) ? process.env.NEXT_PUBLIC_FS_URL + authorData?.profile_image : undefined}
    //                                 size={7.8}
    //                             />
    //                         </div>
    //                         <div className='authorHeader_description'>
    //                             <div className='authorHeader_descriptionLeftBg' />
    //                             <div className='authorHeader_descriptionContent'>
    //                                 <p className='fontSize_16 fontWeight_semiBold authorHeader_descriptionTitle'>
    //                                     {authorData?.full_name}
    //                                 </p>
    //                                 <p className='fontSize_12 authorHeader_descriptionText'>
    //                                     {authorData?.description}
    //                                 </p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <div className='authorBody containerPadding'>
    //                     {
    //                         isModelTitle ? 
    //                         <p className='fontSize_16 fontWeight_bold'>
    //                             {`${isModelTitle} ${t("review_author")}`}
    //                         </p>
    //                         :
    //                         <p className='fontSize_16 fontWeight_bold'>
    //                             {`${authorData?.full_name} ${t("feed")}`}
    //                         </p>
    //                     }
                        
    //                 </div>
    //                 <LatestNewsItem data={newsData?.[0]} loading={loading} type={newsData?.[0]?.type} />
    //                 <NewsItem data={newsData?.[1]} loading={loading} type={newsData?.[1]?.type} />
    //                 <NewsItem data={newsData?.[2]} loading={loading} type={newsData?.[2]?.type} />
    //                 <NewsItem data={newsData?.[3]} loading={loading} type={newsData?.[3]?.type} />
    //                 {
    //                     _.reduce(newsData, (result, value, key) => {
    //                         key > 3 ? 
    //                         result.push(
    //                             <NewsItem key={key} data={value} type={value?.type} />
    //                         )
    //                         :
    //                         null
    //                         return result
    //                     },[])
    //                 }
    //                 {
    //                     _.isEmpty(newsData) &&
    //                     <EmptyData t={t} isLoading={isLoadingNewsList} />
    //                 }
    //                 {/* {
    //                     totalRow > (offset + pageLimit) &&
    //                     <InView as="div" onChange={handleLoadMore} threshold={0.2}>
    //                         <LoadMore t={t} />
    //                     </InView>
    //                 } */}
    //                 {
    //                     (totalRow > (offset + pageLimit) && isLoadingNewsList == false) &&
    //                     <InView as="div" onChange={handleLoadMore}>
    //                         {/* <LoadMore t={t} /> */}
    //                     </InView>
    //                 }
    //                 {
    //                     (totalRow > (offset + pageLimit) && isLoadingNewsList == true) &&
    //                     <LoadMore t={t} />
    //                 }
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //     </div>
    // )
}